import { pathOr } from "ramda";

const state = {
  preflightData: {}
};

const getters = {
  getPreflightData: state => pp => {
    return pathOr({}, ["preflightData", pp], state);
  }
};

const mutations = {
  setPreflightData: (state, payload) => {
    var preflightData = { ...state.preflightData };
    preflightData[payload.code] = payload.preflightData;
    state.preflightData = preflightData;
  },
  setPreflightCheckData: (state, payload) => {
    var filtered = {};
    for (var pp in payload) {
      filtered[pp] = {};
      for (var el in payload[pp]) {
        if (typeof payload[pp][el] == "object") {
          filtered[pp][el] = payload[pp][el];
        }
      }
    }
    var preflightData = { ...state.preflightData, ...filtered };
    state.preflightData = preflightData;
  },
  removePreflightDataPP: (state, payload) => {
    var newState = { ...state.preflightData };
    if (newState[payload]) {
      delete newState[payload];
      state.preflightData = newState;
    }
  }
};

const actions = {
  setPreflightData: ({ commit }, payload) => {
    commit("setPreflightData", payload);
  },
  setPreflightCheckData: ({ commit }, payload) => {
    commit("setPreflightCheckData", payload);
  },
  removePreflightDataPP: ({ commit }, payload) => {
    commit("removePreflightDataPP", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
